import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { NoteCompleteTemplate } from 'components/Templates'

const NoteComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTopPage = useCallback(() => {
    dispatch(push('/account'))
  }, [])

  return (
    <Layout title={'完了 | 特定商取引法に関する記載'}>
      <NoteCompleteTemplate backToTop={backToTopPage} />
    </Layout>
  )
}

export default NoteComplete
